import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import remove from '../../../../../Res/Icon/remove.png';
import firmwareUpgrade from '../../../../../Res/Icon/firmwareUpgrade.svg';
import vadEnabled from '../../../../../Res/Icon/vadEnabled.svg';
import vadDisabled from '../../../../../Res/Icon/vadDisabled.svg';
import epiReboot from '../../../../../Res/Icon/epiReboot.svg';
import executeProvision from '../../../../../Res/Icon/executeProvision.svg'
import './BoxObi.css';
import { connect } from 'react-redux';
import {
  updateEpisFirmwareManually,
  getEpikBoxData,
  updateVad,
  provisionNow,
  getCurrentAtaVersions
} from '../../../../../actions/EpikBoxes';
import Spinner from '../../../../Spinner/Spinner';
import ConfirmationModal from '../../../../ConfirmationModal';
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import { createPortal } from 'react-dom';
import { UncontrolledTooltip } from 'reactstrap';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';
import { toast } from 'react-toastify';
import { shouldToggleVAD } from '../../../../../utils/shouldToggleVAD';
import TooltipCustom from '../../TooltipCustom';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';

class BoxObi extends Component {
  constructor() {
    super();
    this.token = localStorage.getItem('jwtToken') || null;
    this.state = {
      isLoading: false,
      epiFwUpdate: false,
      selectedObi: null,
      isVadLoading: [],
      provisionLoading: [],
      AtaTooltipData: null,
      ataTooltipLoading: true,
      deleteEpi: false
    };
  }
  async componentDidMount() {
    const { boxDetails, getCurrentAtaVersions, user } = this.props;

    const vpnAddress = boxDetails?.vpnAddress;
    const deleteEpiPermission = getPermissionForComponent('deleteEpi', user.permissionsGroup);
    this.setState({ deleteEpi: deleteEpiPermission })

    if (!boxDetails?.serialNumber?.startsWith('E-')) {
      const AtaTooltipData = await getCurrentAtaVersions(this.token, vpnAddress);
      this.setState({ AtaTooltipData });
    }

    this.setState({ ataTooltipLoading: false })
  }

  handleRebootObi = obi => {
    const { obiReboot } = this.props;
    obiReboot(obi?.deviceId);
  };

  updateEpiFirmware = obi => {
    this.setState({ epiFwUpdate: true, selectedObi: obi._id });
  };

  onConfirmEPIReboot = async obi => {
    const { boxDetails, updateEpisFirmwareManually, getEpikBoxData } = this.props;
    this.setState({ isLoading: true });

    await updateEpisFirmwareManually(this.token, boxDetails._id, obi?.macAddress);
    await getEpikBoxData(this.token, boxDetails._id);

    this.setState({ isLoading: false, epiFwUpdate: false });
  };
  onVadChange = async (obi, enable, index) => {
    const { boxDetails, updateVad, getEpikBoxData } = this.props;
    this.setState({ isVadLoading: [...this.state.isVadLoading, index] });

    await updateVad(this.token, obi?._id, enable);
    await getEpikBoxData(this.token, boxDetails._id);

    this.setState({ isVadLoading: this.state.isVadLoading.filter(idx => idx != index) });
  };

  onProvisionNow = async (obi, index) => {
    const { boxDetails, provisionNow } = this.props;
    this.setState({ provisionLoading: [...this.state.provisionLoading, index] });

    const response = await provisionNow(this.token, boxDetails?._id, obi?.macAddress)
    if (response) {
      toast.success(response)
    }

    this.setState({ provisionLoading: this.state.provisionLoading.filter(idx => idx !== index) });
  }

  renderModal(obi) {
    const { epiFwUpdate, selectedObi } = this.state;
    if (epiFwUpdate && obi._id === selectedObi) {
      return createPortal(
        <ConfirmationModal
          isOpen={epiFwUpdate}
          onCancel={() => {
            this.setState({ epiFwUpdate: false });
          }}
          headerText={`EPI Firmware Update Required`}
          bodyText={`There is a firmware update required on the EPI's on the device. This process will take approximately 15 minutes to complete and require the ports on this device to reboot. Would you like to proceed with this update now?`}
          onConfirm={() => this.onConfirmEPIReboot(obi)}
        />,
        document.body, // Render the modal outside the component's DOM hierarchy
      );
    }
  }

  checkIsEPIBelongsToExpansionBox = (id) => {
    const { boxDetails } = this.props;
    const expansionObis = boxDetails?.slaveBoxes?.[0]?.removedObis || []
    return expansionObis.includes(id)
  }

  render() {
    const {
      onObiSelect,
      onBoxEpiDelete,
      selected,
      enableBoxEdit,
      user,
      boxObisDetails,
    } = this.props;
    const { isLoading } = this.state;
    const { setDcUpdatePopup } = this.props; // Destructuring from props
    const epiFirmwareUpdatePermission = getPermissionForComponent(
      'epiFirmwareUpdate',
      user.permissionsGroup,
    );

    const activeBtnStyle = {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
    };
    return (
      <>
        {boxObisDetails.length > 0 &&
          boxObisDetails.map(({ obi, portObiSystemStatus, isPlaceholder }, index) => {
            // Skip if MAC address is missing
            if (!obi?.macAddress) {
              return null;
            }
            const obiSelected = selected && selected._id === obi._id;
            const containerClassName = obiSelected ? 'boxObiContainer selected' : 'boxObiContainer';
            const obiStatus = portObiSystemStatus?.sp1ServiceStatus?.status;
            const obiCondition =
              obiStatus?.startsWith('Registered') && obiStatus?.includes('172.16.16.1');
            const active = obiCondition ? true : false;
            const isToggleVAD = shouldToggleVAD(obi?.fwVersion);
            const IS_ESCENE_ATA = obi?.macAddress.startsWith('0026');
            const isObiBelongsToExpansionBox = this.checkIsEPIBelongsToExpansionBox(obi._id)

            const expansionBoxClass = isObiBelongsToExpansionBox ? 'expansionBoxEpis' : '';

            return (
              <>
                <div
                  key={index}
                  className={`${containerClassName} ${expansionBoxClass}`}
                  onClick={() => {
                    onObiSelect(obi);
                  }}
                >
                  {isLoading ? <Spinner /> : null}
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      paddingLeft: '5px',
                      paddingTop: '2px',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        style={{
                          width: '20px',    
                          height: '20px',  
                          position: 'relative', 
                        }}
                      >
                        {isPlaceholder ? (
                          <div
                            className="loader with-custom-colors"
                          />
                        ) : (
                          active ? (
                            <div
                              style={{
                                ...activeBtnStyle,
                                background: '#0cd60c',
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                ...activeBtnStyle,
                                background: '#ffc107',
                              }}
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <strong>{`EPI #${index + 1}`}</strong>
                  </div>
                  <div className="obiInfo" id={`obiInfo-${obi?.macAddress}`}>
                    <TooltipCustom
                      tipId={`obiInfo-${obi?.macAddress}`}
                      displayData={
                        this.state.ataTooltipLoading
                          ? "Loading Version..."
                          : this.state.AtaTooltipData?.[obi?.macAddress]?.epiFirmwareVersion || "Version Not Specified"
                      }
                    />
                    <div className="infoLabel">
                      <FontAwesomeIcon fixedWidth className="labelIcon" icon="microchip" />
                      <h5>MAC Address</h5>
                    </div>
                    <span>{obi?.macAddress || 'N/A'}</span>
                  </div>
                  <div className="epi-footer">
                    <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto' }}>
                      <TooltipIcon
                        tipId={`${'reboot-epi'}-${obi?.macAddress
                          ?.replace(/\\{0,1}t|\\{1,2}$/gi, '')
                          ?.trim()}`}
                        onClick={() => {
                          const divElement = document.getElementById('test-time-remaining');
                          const isHidden = divElement.getAttribute('hidden') !== null;
                          if (isHidden) {
                            setDcUpdatePopup({ show: true });
                          } else {
                            this.handleRebootObi(obi);
                          }
                        }}
                        imgSrc={epiReboot}
                        displayData="Reboot EPI"
                        placement="top"
                        customClass="epi-info"
                        customStyle={{
                          position: 'relative',
                          top: '3px',
                          height: '20px',
                        }}
                      />
                    </div>
                    {IS_ESCENE_ATA && (
                      <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto' }} id={'provision-now' + index}>
                        {this.state.provisionLoading.includes(index) ? (
                          <SpinnerCircles red={true} />
                        ) : null}
                        <div hidden={this.state.provisionLoading.includes(index)}>
                          <TooltipIcon
                            tipId={'provision-now' + index}
                            onClick={() => this.onProvisionNow(obi, index)}
                            imgSrc={executeProvision}
                            displayData="Provision Now"
                            placement="top"
                            customClass="epi-info"
                            customStyle={{
                              position: 'relative',
                              top: '3px',
                              height: '20px',
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {IS_ESCENE_ATA && (
                      <div id={'vad-icon' + index}>
                        {this.state.isVadLoading.includes(index) ? (
                          <SpinnerCircles red={true} />
                        ) : null}
                        <div hidden={this.state.isVadLoading.includes(index)}>
                          {
                            isToggleVAD ? obi?.vadEnable ?
                              <TooltipIcon
                                tipId={'vad-icon' + index}
                                onClick={() => this.onVadChange(obi, !!!obi?.vadEnable, index)}
                                imgSrc={vadEnabled}
                                displayData={`Disable VAD(Voice Activity Detection.`}
                                placement="top"
                                customClass="epi-info"
                                customStyle={{
                                  position: 'relative',
                                  top: '3px',
                                  height: '18px',
                                }}
                              /> :
                              <TooltipIcon
                                tipId={'vad-icon' + index}
                                onClick={() => this.onVadChange(obi, !!!obi?.vadEnable, index)}
                                imgSrc={vadDisabled}
                                displayData={`Enable VAD(Voice Activity Detection.`}
                                placement="top"
                                customClass="epi-info"
                                customStyle={{
                                  position: 'relative',
                                  top: '3px',
                                  height: '18px',
                                }}
                              /> : null
                          }
                        </div>
                      </div>
                    )}
                    {IS_ESCENE_ATA && (epiFirmwareUpdatePermission === 'write' || epiFirmwareUpdatePermission === 'both') && (
                      <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto' }}>
                        <TooltipIcon
                          tipId={`${'update-epi'}-${obi?.macAddress
                            ?.replace(/\\{0,1}t|\\{1,2}$/gi, '')
                            ?.trim()}`}
                          onClick={() => {
                            const divElement = document.getElementById('test-time-remaining');
                            const isHidden = divElement.getAttribute('hidden') !== null;
                            if (isHidden) {
                              setDcUpdatePopup({ show: true });
                            } else {
                              this.updateEpiFirmware(obi);
                            }
                          }}
                          imgSrc={firmwareUpgrade}
                          displayData="EPI Firmware Update"
                          placement="top"
                          customClass="epi-info"
                          customStyle={{
                            position: 'relative',
                            top: '3px',
                            height: '30px',
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {enableBoxEdit && this.state.deleteEpi && (
                  <div
                    className="delete-box-icon"
                    onClick={
                      (this.state.deleteEpi === 'write' || this.state.deleteEpi === 'both')
                        ? () => {
                            const divElement = document.getElementById('test-time-remaining');
                            const isHidden = divElement.getAttribute('hidden') !== null;
                            if (isHidden) {
                              setDcUpdatePopup({ show: true });
                            } else {
                              onBoxEpiDelete(obi);
                            }
                          }
                        : undefined // No click handler if not allowed
                    }
                    style={{ pointerEvents: this.state.deleteEpi === 'read' ? 'none' : 'auto', display: isObiBelongsToExpansionBox ? 'none' : '' }}
                  >
                    <img
                      className="actions-icon"
                      style={{
                        position: 'relative',
                        right: '2.5rem',
                        top: '3px',
                        height: '20px',
                      }}
                      src={remove}
                      alt="remove"
                    />
                  </div>
                )}
                {this.renderModal(obi)}
              </>
            );
          })}
      </>
    );
  }
}

BoxObi.propTypes = { obi: PropTypes.any };

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    boxDetails: state.AppState.boxDetails.box,
    permissionGroup: state.AppState.permissionGroup,
  };
};

const mapDispatchToProps = dispatch => ({
  updateEpisFirmwareManually: (token, bid, macAddress) =>
    dispatch(updateEpisFirmwareManually(token, bid, macAddress)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
  getCurrentAtaVersions: (token, vpnAddress) => dispatch(getCurrentAtaVersions(token, vpnAddress)),
  updateVad: (token, obiId, enable) => dispatch(updateVad(token, obiId, enable)),
  provisionNow: (token, boxId, macAddress) => dispatch(provisionNow(token, boxId, macAddress))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoxObi);

